import { MymeType } from '@myme/utils';
import { CourseIcon, MymeLocationBasedIcon, MymeTimeBasedIcon } from 'src/icons';

export const mapMymeTypeToIcon = (mymeType: MymeType) => {
  switch (mymeType) {
    case 'TIME_BASED': {
      return <MymeTimeBasedIcon fill='inherit' />;
    }
    case 'COURSE': {
      return <CourseIcon fill='inherit' />;
    }
    case 'LOCATION_BASED':
    default: {
      return <MymeLocationBasedIcon fill='inherit' />;
    }
  }
};
